<form class="lf-form" [class.lf-form--compact]="compact()" (ngSubmit)="submit()" novalidate>
  <div class="lf-form__head">
    <h3>Get Free Expert Counseling</h3>
    <p>Complete in 2 minutes · No obligation · 100% confidential</p>
  </div>

  <div class="lf-form__progress" role="progressbar" [attr.aria-valuenow]="progressPercent" aria-valuemin="0" aria-valuemax="100">
    <div class="lf-form__progress-bar" [style.width.%]="progressPercent"></div>
  </div>

  <ol class="lf-form__steps" aria-label="Form progress">
    @for (step of steps; track step.id) {
      <li
        class="lf-form__step"
        [class.lf-form__step--active]="currentStep() === step.id"
        [class.lf-form__step--done]="currentStep() > step.id"
      >
        <button type="button" class="lf-form__step-btn" (click)="goToStep(step.id)">
          <span class="lf-form__step-num">{{ step.id }}</span>
          <span class="lf-form__step-label">{{ step.label }}</span>
        </button>
      </li>
    }
  </ol>

  @if (currentStep() === 1) {
    <div class="lf-form__panel">
      <h4 class="lf-form__panel-title">Basic Information</h4>
      <div class="lf-form__grid">
        <label class="lf-field lf-field--full">
          <span>Full Name <em>*</em></span>
          <input
            type="text"
            name="fullName"
            [(ngModel)]="form.fullName"
            placeholder="e.g. Aanya Patel"
            autocomplete="name"
            [class.lf-field--invalid]="fieldErrors().fullName"
          />
          @if (fieldErrors().fullName) {
            <small class="lf-field__error">{{ fieldErrors().fullName }}</small>
          }
        </label>
        <label class="lf-field">
          <span>Mobile Number <em>*</em></span>
          <input
            type="tel"
            name="phoneNumber"
            [(ngModel)]="form.phoneNumber"
            placeholder="+91 98765 43210"
            autocomplete="tel"
            [class.lf-field--invalid]="fieldErrors().phoneNumber"
          />
          @if (fieldErrors().phoneNumber) {
            <small class="lf-field__error">{{ fieldErrors().phoneNumber }}</small>
          }
        </label>
        <label class="lf-field">
          <span>WhatsApp Number</span>
          <input
            type="tel"
            name="whatsappNumber"
            [(ngModel)]="form.whatsappNumber"
            placeholder="Same as mobile if applicable"
            autocomplete="tel"
          />
        </label>
        <label class="lf-field lf-field--full">
          <span>Email ID <em>*</em></span>
          <input
            type="email"
            name="email"
            [(ngModel)]="form.email"
            placeholder="you@email.com"
            autocomplete="email"
            [class.lf-field--invalid]="fieldErrors().email"
          />
          @if (fieldErrors().email) {
            <small class="lf-field__error">{{ fieldErrors().email }}</small>
          }
        </label>
        <label class="lf-field">
          <span>City <em>*</em></span>
          <input
            type="text"
            name="city"
            [(ngModel)]="form.city"
            placeholder="Your city"
            autocomplete="address-level2"
            [class.lf-field--invalid]="fieldErrors().city"
          />
          @if (fieldErrors().city) {
            <small class="lf-field__error">{{ fieldErrors().city }}</small>
          }
        </label>
        <label class="lf-field">
          <span>State</span>
          <select name="state" [(ngModel)]="form.state">
            <option value="">Select state</option>
            @for (s of stateOptions; track s) {
              <option [value]="s">{{ s }}</option>
            }
          </select>
        </label>
        <label class="lf-field">
          <span>Country</span>
          <select name="country" [(ngModel)]="form.country">
            @for (c of countryOptions; track c) {
              <option [value]="c">{{ c }}</option>
            }
          </select>
        </label>
      </div>
    </div>
  }

  @if (currentStep() === 2) {
    <div class="lf-form__panel">
      <h4 class="lf-form__panel-title">Academic Information</h4>
      <div class="lf-form__grid">
        <label class="lf-field lf-field--full">
          <span>Current Qualification <em>*</em></span>
          <select
            name="qualification"
            [(ngModel)]="form.qualification"
            [class.lf-field--invalid]="fieldErrors().qualification"
          >
            <option value="">Select qualification</option>
            @for (q of qualificationOptions; track q) {
              <option [value]="q">{{ q }}</option>
            }
          </select>
          @if (fieldErrors().qualification) {
            <small class="lf-field__error">{{ fieldErrors().qualification }}</small>
          }
        </label>
        <label class="lf-field">
          <span>Percentage / CGPA</span>
          <input
            type="text"
            name="percentageOrCgpa"
            [(ngModel)]="form.percentageOrCgpa"
            placeholder="e.g. 78% or 8.2 CGPA"
          />
        </label>
        <label class="lf-field">
          <span>Passing Year</span>
          <input
            type="text"
            name="passingYear"
            [(ngModel)]="form.passingYear"
            placeholder="e.g. 2024"
          />
        </label>
        <label class="lf-field lf-field--full">
          <span>Current Institution</span>
          <input
            type="text"
            name="institution"
            [(ngModel)]="form.institution"
            placeholder="College / University name"
          />
        </label>
      </div>
    </div>
  }

  @if (currentStep() === 3) {
    <div class="lf-form__panel">
      <h4 class="lf-form__panel-title">Study Abroad Preferences</h4>
      <div class="lf-form__grid">
        <label class="lf-field">
          <span>Preferred Country <em>*</em></span>
          <select
            name="preferredDestination"
            [(ngModel)]="form.preferredDestination"
            [class.lf-field--invalid]="fieldErrors().preferredDestination"
          >
            <option value="">Select country</option>
            @for (d of destinationOptions(); track d) {
              <option [value]="d">{{ d }}</option>
            }
          </select>
          @if (fieldErrors().preferredDestination) {
            <small class="lf-field__error">{{ fieldErrors().preferredDestination }}</small>
          }
        </label>
        <label class="lf-field">
          <span>Preferred Course <em>*</em></span>
          <select
            name="preferredCourse"
            [(ngModel)]="form.preferredCourse"
            [class.lf-field--invalid]="fieldErrors().preferredCourse"
          >
            <option value="">Select course</option>
            @for (c of courseOptions; track c) {
              <option [value]="c">{{ c }}</option>
            }
          </select>
          @if (fieldErrors().preferredCourse) {
            <small class="lf-field__error">{{ fieldErrors().preferredCourse }}</small>
          }
        </label>
        <label class="lf-field">
          <span>Intake <em>*</em></span>
          <select
            name="intake"
            [(ngModel)]="form.intake"
            [class.lf-field--invalid]="fieldErrors().intake"
          >
            <option value="">Select intake</option>
            @for (i of intakeOptions; track i) {
              <option [value]="i">{{ i }}</option>
            }
          </select>
          @if (fieldErrors().intake) {
            <small class="lf-field__error">{{ fieldErrors().intake }}</small>
          }
        </label>
        <label class="lf-field">
          <span>Budget Range</span>
          <select name="budgetRange" [(ngModel)]="form.budgetRange">
            <option value="">Select budget</option>
            @for (b of budgetOptions; track b) {
              <option [value]="b">{{ b }}</option>
            }
          </select>
        </label>
        <label class="lf-field">
          <span>Passport Available</span>
          <select name="passportStatus" [(ngModel)]="form.passportStatus">
            <option value="">Select</option>
            @for (y of yesNoOptions; track y) {
              <option [value]="y">{{ y }}</option>
            }
          </select>
        </label>
        <label class="lf-field">
          <span>IELTS / PTE Status</span>
          <select name="englishTestStatus" [(ngModel)]="form.englishTestStatus">
            <option value="">Select status</option>
            @for (e of englishTestOptions; track e) {
              <option [value]="e">{{ e }}</option>
            }
          </select>
        </label>
        <label class="lf-field">
          <span>Loan Requirement</span>
          <select name="loanRequired" [(ngModel)]="form.loanRequired">
            <option value="">Select</option>
            @for (y of yesNoOptions; track y) {
              <option [value]="y">{{ y }}</option>
            }
          </select>
        </label>
      </div>
    </div>
  }

  @if (submitError()) {
    <p class="lf-form__alert lf-form__alert--error">{{ submitError() }}</p>
  }
  @if (submitOk()) {
    <p class="lf-form__alert lf-form__alert--success">{{ submitOkMessage() }}</p>
  }

  <div class="lf-form__actions">
    @if (currentStep() > 1) {
      <button type="button" class="h1-btn h1-btn--ghost" (click)="prevStep()">Back</button>
    }
    @if (currentStep() < steps.length) {
      <button type="button" class="h1-btn h1-btn--accent h1-btn--block" (click)="nextStep()">
        Continue
      </button>
    } @else {
      <button
        type="submit"
        class="h1-btn h1-btn--accent h1-btn--lg h1-btn--block"
        [disabled]="submitting()"
      >
        {{ submitting() ? 'Submitting…' : 'Get Free Counseling →' }}
      </button>
    }
  </div>

  <p class="lf-form__legal">
    By submitting, you agree to our
    <a href="https://careergradglobal.com/terms" target="_blank" rel="noopener">Terms</a>
    &amp;
    <a href="https://careergradglobal.com/privacy" target="_blank" rel="noopener">Privacy Policy</a>.
    Your data is secure and never shared without consent.
  </p>

  <div class="lf-form__trust" aria-label="Trust indicators">
    <span>🔒 SSL Secured</span>
    <span>✓ GDPR Compliant</span>
    <span>★ 4.9/5 Rating</span>
  </div>
</form>
